import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'store/reducers';
import { initApp } from 'store/actions/app';

export default (initialState = {}) => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
  const middleware = applyMiddleware(thunkMiddleware);
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(middleware),
  );
  store.dispatch(initApp());
  return store;
};
